<template>
	<o-section title="Création d'un utilisateur">
		<hr>

		<div v-if="!setup.emailChecked">
			<h4>Étape 1 • Vérification de l'email</h4>
			<div>Entrez l'email de l'utilisateur afin de vérifier s'il est déjà enregistré.</div>

			<hr>

			<o-input
				v-model="setup.user.email"
				type="email"
				label="Email"
				validation="email"
				validation-error-message="Un email valide est requis"
				required
				autofocus
				@keydown.enter="setup.debouncedCheckEmailAsync()"/>

			<div class="text--right">
				<o-button
					color="info"
					@click="setup.debouncedCheckEmailAsync()">
					Vérifier l'email
				</o-button>
			</div>
		</div>

		<div v-else-if="setup.user.email">
			<h4>Étape 2 • {{ setup.userExist ? `Informations complémentaires` : `Association de l'utilisateur` }}</h4>
			<o-alert
				v-if="setup.userExist"
				color="info"
				center>
				Cet utilisateur est déjà enregistré.
			</o-alert>
			<o-alert
				v-else
				color="info"
				center>
				Cet utilisateur n'est pas encore enregistré. Veuillez saisir les informations complémentaires.
			</o-alert>

			<hr>

			<div class="flex fd-c g-xs">
				<o-input
					v-model="setup.user.email"
					type="email"
					label="Email"
					disabled
					:validation="setup.validator.rule('email')"
					validation-error-message="Un email valide est requis"/>
				<o-input
					:ref="setup._firstName"
					v-model="setup.user.firstName"
					label="Prénom"
					:disabled="setup.userExist"
					:validation="setup.validator.rule('firstName')"
					validation-error-message="Le prénom est requis"/>
				<o-input
					v-model="setup.user.lastName"
					label="Nom"
					:disabled="setup.userExist"
					:validation="setup.validator.rule('lastName')"
					validation-error-message="Le nom est requis"/>
			</div>

			<br>

			<o-alert center>
				Il sera possible d'associer des rôles et des sociétés à cet utilisateur après {{ setup.userExist ? `son association` : `sa création` }}.
			</o-alert>

			<hr>

			<o-section
				v-if="setup.emailChecked"
				align="right">
				<o-button
					outline
					prefix-font-icon="icon-interface-arrows-button-left"
					@click="setup.goToStep1()">
					Retour
				</o-button>
				<o-button
					v-if="setup.userExist"
					color="info"
					@click="setup.associateUserAsync()">
					Associer l'utilisateur
				</o-button>
				<o-button
					v-else
					color="info"
					@click="setup.createUserAsync()">
					Créer l'utilisateur
				</o-button>
			</o-section>
		</div>
	</o-section>
</template>

<script setup lang="ts">
import OrganizationUserAsideNewSetupService from '@/setup/organization-user/OrganizationUserAsideNewSetupService';
import { inject } from 'vue';
const _aside = inject<OrionAside>('_aside');
const props = defineProps(OrganizationUserAsideNewSetupService.props);
const setup = new OrganizationUserAsideNewSetupService(props, _aside);
</script>
